import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React from "react";

type DateColumnProps = {
  date: string | Date | undefined;
};

export const DateColumn = ({ date }: DateColumnProps): JSX.Element => {
  const { formatDate } = useDateFormatter();
  return <span>{date ? formatDate(date) : "-"}</span>;
};
